export const PER_PAGE = 150;
export const HOLD_BIN_PER_PAGE = 50;
export const getDefaultCartPageSize = (cartName?: string) => {
	return cartName === "hold-bin" ? HOLD_BIN_PER_PAGE : PER_PAGE;
};
